var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"min-height-screen h-full",attrs:{"flat":"","elevation":"0"}},[_c('div',{staticClass:"h-full w-full"},[_c('div',{staticClass:"d-flex h-full w-full align-center justify-center"},[_c('loader')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }